import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addData } from '../api/addData.ts';

export const useAddData = <T>(collectionName: string, cb?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (item: T) => addData(collectionName, item),
    onSuccess: (resp) => {
      queryClient.invalidateQueries({ queryKey: [collectionName] });
      if (cb) {
        cb(resp);
      }
    },
    onError: (error) => {
      console.error(`Error while adding new item to ${collectionName}:`, error);
    },
  });
};
